// Import dependency here
import axios from "axios";
import encryptMessage from './encrypt';
import decryptMessage from './decrypt';
// import { toast } from "react-toastify";

// Import redux store here
// import { store } from "../redux/store";

const apiCall = async ({
  url,
  method = "get",
  data = null,
  headers = { "Content-type": "application/json" },
  accessToken = "",
  showToaster = true,
  retries = 3,
  retryDelay = 1000,
}) => {
  let lastError = null;

  // Retry logic
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      // import base url from the env
      const Base_Url = process.env.REACT_APP_BASE_URL + url;
      // BODY ENCRYPT
      // Check if it's a login endpoint
      const isLoginEndpoint = url.includes("login");
      const isProduction = process.env.REACT_APP_NODE_ENV === "production";
      if(isProduction) {
        data = encryptMessage(data);
      }
      const response = await axios({
        method,
        url: Base_Url,
        data,
        headers: {
          ...headers,
        },
        timeout: 30000, // 30 second timeout
      });

      // if response status is success than show success toaster
      if (response.status === 200 || response.status === 201) {
        //   if (method === "post" || method === "put" || method === "delete") {
        // toast.success(response.data.message, {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "light",
        // });
        //   }
        let responseData = response.data;
        if(isProduction) {
          responseData = decryptMessage(response.data);
        }

        // Return with success flag
        return {
          success: true,
          ...responseData
        };
      }
    } catch (error) {
      console.log(`API ERROR (Attempt ${attempt + 1}/${retries}):`, error.message);
      lastError = error;

      // If this is not the last attempt and it's a network error, retry
      if (attempt < retries - 1 && (
        error.code === 'ECONNABORTED' ||
        error.code === 'ERR_NETWORK' ||
        !error.response
      )) {
        console.log(`Retrying in ${retryDelay}ms...`);
        await new Promise(resolve => setTimeout(resolve, retryDelay * (attempt + 1)));
        continue;
      }

      // For the last attempt or non-retryable errors, handle the error
      let responseData = null;
      try {
        if (error?.response?.data) {
          const isProduction = process.env.REACT_APP_NODE_ENV === "production";
          responseData = isProduction ? decryptMessage(error.response.data) : error.response.data;
        }
      } catch (decryptError) {
        console.log("Error decrypting response:", decryptError);
      }

      // Return error response with success flag
      return {
        success: false,
        error: true,
        message: responseData?.message || error.message || "Network error occurred",
        return_code: responseData?.return_code || "network_error",
        originalError: error,
        ...responseData
      };
      // if (error?.response?.data?.return_code === "token_not_valid") {
      //   localStorage.removeItem("accessToken");
      //   localStorage.removeItem("refreshToken");
      //   localStorage.removeItem("isLogin");
      //   localStorage.removeItem("persist:root");
      //   store.dispatch({ type: "LOGOUT" });
      // }
      // if response status is fail than show error toaster
      // toast.error(error.response.data?.message, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      // console.error("API Error:", error);
    }
  }

  // This should never be reached, but just in case
  return {
    success: false,
    error: true,
    message: "Maximum retries exceeded",
    return_code: "max_retries_exceeded"
  };
};

export default apiCall;
